import HOC from "../../components/HOC";
import DefectaList from "../../components/screen/defecta/DefectaList";
import PageTemplateNew from "../../components/common/particles.jsx/PageTemplateNew";
import BreadcrumbDefecta from "../../components/screen/defecta/defectaComponents/BreadcrumbDefecta";

const DefectaArchivePage = ({ isWarehouse }) => {
  return (
    <PageTemplateNew
      header={`Archive Defecta ${isWarehouse ? "Central Warehouse" : ""}`}
      mainComponent={<DefectaList isWarehouse={isWarehouse} isArchive={true} />}
      pageRole={isWarehouse ? 49 : 48}
      breadcrumb={
        <BreadcrumbDefecta isWarehouse={isWarehouse ? isWarehouse : false} />
      }
    />
  );
};

export default HOC(DefectaArchivePage);
